import { render, staticRenderFns } from "./SubPropertyTablePanel.vue?vue&type=template&id=569b69ce"
import script from "./SubPropertyTablePanel.vue?vue&type=script&lang=js"
export * from "./SubPropertyTablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports